import React, { useState } from "react";
import {
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    InputAdornment
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";
import sortBy from "../../../../../assets/AccountingModule/filter.svg";
import edit from "../../../../../assets/AccountingModule/edit2.svg";
import view from "../../../../../assets/AccountingModule/view.svg";
import deleteIcon from "../../../../../assets/AccountingModule/delete.svg";
import { ReactComponent as Cart } from "../../../../../assets/AccountingModule/cart.svg";
import Modal from "../../../../../components/Modal";
import dropDownBlack from "../../../../../assets/AccountingModule/dropdown_black.svg";
import styles from "./style";
import { formatDate } from "../../../../../utils/DateFormat";

const PurchaseSupplierList = ({
    purchaseOrderData,
    total,
    currentPage,
    setCurrentPage,
    rowsPerPage,
    setRowsPerPage,
    handleDelete
}) => {
    const navigate = useNavigate();
    const [item, setItem] = useState(null);
    const [opens, setOpens] = useState(false);

    const handleNavigate = (item) => {
        navigate("/dashboard/purchaseOrderEdit", { state: { item } });
    };

    const handleNavigateView = (item) => {
        navigate("/dashboard/purchaseOrderView", { state: { item } });
    };

    const handleDeleteItem = (deleteId) => {
        handleDelete(deleteId)
        setOpens(false);
    };
    const renderPaginationNumbers = () => {
        const totalPages = purchaseOrderData.length / rowsPerPage;
        const pageNumbers = [];

        pageNumbers.push(
            <Button
                key="prev"
                className="prev"
                sx={styles.paginationButton}
                onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
            >
                {"<"}
            </Button>
        );

        pageNumbers.push(
            <Button
                key={1}
                className={`page ${currentPage === 1 ? "active" : ""}`}
                sx={styles.paginationButton}
                onClick={() => setCurrentPage(1)}
            >
                1
            </Button>
        );

        if (currentPage > 3) {
            pageNumbers.push(
                <Typography key="ellipsis1" component="span" sx={styles.ellipsis}>
                    ...
                </Typography>
            );
        }

        for (
            let i = Math.max(2, currentPage - 1);
            i <= Math.min(totalPages - 1, currentPage + 1);
            i++
        ) {
            if (i === currentPage - 1 || i === currentPage || i === currentPage + 1) {
                pageNumbers.push(
                    <Button
                        key={i}
                        className={`page ${i === currentPage ? "active" : ""}`}
                        sx={styles.paginationButton}
                        onClick={() => setCurrentPage(i)}
                    >
                        {i}
                    </Button>
                );
            }
        }

        // Add ellipsis
        if (currentPage < totalPages - 2) {
            pageNumbers.push(
                <Typography key="ellipsis2" component="span" sx={styles.ellipsis}>
                    ...
                </Typography>
            );
        }

        // Last page
        if (totalPages > 1) {
            pageNumbers.push(
                <Button
                    key={totalPages}
                    className={`page ${currentPage === totalPages ? "active" : ""}`}
                    sx={styles.paginationButton}
                    onClick={() => setCurrentPage(totalPages)}
                >
                    {totalPages}
                </Button>
            );
        }

        pageNumbers.push(
            <Button
                key="next"
                className="next"
                sx={styles.paginationButton}
                onClick={() =>
                    currentPage < totalPages && setCurrentPage(currentPage + 1)
                }
                disabled={currentPage === totalPages}
            >
                {">"}
            </Button>
        );

        return pageNumbers;
    };

    return (
        <>
            <Box px="20px" mt={2}>
                <Box sx={styles.header}>
                    <Box>
                        <Typography sx={styles.headerText}>Purchase Order</Typography>
                    </Box>
                    <Box>
                        <Button variant="contained" color="success" sx={styles.checkinBtn} onClick={() => navigate("/dashboard/addPurchase")}> <Cart />Add Purchase
                        </Button>
                    </Box>
                </Box>
            </Box>
            <Box sx={styles.container}>
                <Box sx={styles.filterSection}>
                    <Box sx={styles.searchContainer}>
                        <input
                            type="text"
                            placeholder="Search"
                            style={styles.searchInput}
                        />
                    </Box>
                    <Box sx={styles.sortByContainer}>
                        <img src={sortBy} alt="sortBy" />
                        <Typography sx={styles.sortByText}>Sort By</Typography>
                    </Box>
                </Box>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={styles.tableCell}>Date</TableCell>
                                <TableCell sx={styles.tableCell}>Purchase#</TableCell>
                                <TableCell sx={styles.tableCell}>Vendor Name</TableCell>
                                <TableCell sx={styles.tableCell}>Status</TableCell>
                                <TableCell sx={styles.tableCell}>Bill Status </TableCell>
                                <TableCell sx={styles.tableCell}>Amount</TableCell>
                                <TableCell sx={styles.tableCell}>Delivery Date</TableCell>
                                <TableCell sx={styles.tableCell}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {purchaseOrderData.map((row) => (
                                <TableRow key={row._id}>
                                    <TableCell sx={styles.tableCells}>
                                        {row?.purchaseOrderDate
                                            ? formatDate(row.purchaseOrderDate)
                                            : "-"}
                                    </TableCell>
                                    <TableCell sx={styles.tableCells}>
                                        {row?.purchaseOrderNumber || "-"}
                                    </TableCell>
                                    <TableCell sx={styles.tableCells}>
                                        {row?.supplier?.name || "-"}
                                    </TableCell>
                                    <TableCell sx={styles.statusCell}>
                                        <Typography
                                            sx={{
                                                ...styles.statusChip,
                                                color: getStatusColor(row?.status).color,
                                            }}
                                        >
                                            {row?.status}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={styles.tableCells}>
                                        {row?.billStatus || "-"}
                                    </TableCell>
                                    <TableCell sx={styles.tableCells}>
                                        {row.grandTotal
                                            ? `${row.grandTotal.toLocaleString()}`
                                            : "-"}
                                    </TableCell>
                                    <TableCell sx={styles.tableCells}>
                                        {row?.deliveryDate
                                            ? formatDate(row.deliveryDate)
                                            : "-"}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleNavigate(row)}
                                        >
                                            <img src={edit} alt="edit" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleNavigateView(row)}
                                        >
                                            <img src={view} alt="view" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                setItem(row);
                                                setOpens(true);
                                            }}
                                        >
                                            <img src={deleteIcon} alt="delete" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={styles.paginationContainer}>
                    <Box sx={styles.rowsPerPageContainer}>
                        <Typography sx={styles.rowsPerPageText}>Show:</Typography>
                        <select
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(Number(e.target.value))}
                            style={styles.rowsPerPageSelect}
                        >
                            <option value={10}>10 Rows</option>
                            <option value={20}>20 Rows</option>
                            <option value={30}>30 Rows</option>
                        </select>
                        <img src={dropDownBlack} alt="dropdown" style={styles.selectIcon} />
                    </Box>
                    <Box sx={styles.paginationBox}>{renderPaginationNumbers()}</Box>
                </Box>
            </Box >
            <Modal
                open={opens}
                setOpen={setOpens}
                deletetText={"Delete"}
                cancelText={"Cancel"}
                title={"Delete Credit Note"}
                handleDelete={() => handleDeleteItem(item?._id)}
            >
                <Box>
                    <Typography>Are you sure you want to delete this quote?</Typography>
                </Box>
            </Modal>
        </>
    );
};

// Helper function to get status colors
const getStatusColor = (status) => {
    switch (status) {
        case "Draft":
            return { color: "#878787" };
        case "Open":
            return { color: "#00ABF4" };
        case "Closed":
            return { color: "#28AA4A" };
        case "Cancelled":
            return { color: "#e93030" };
        default:
            return { color: "#000000", bgColor: "#FFFFFF" };
    }
};

export default PurchaseSupplierList;
